export abstract class ErrorHandler {
  abstract code?: number;
  abstract shouldReport(): boolean;

  getCode(): number | undefined {
    return this.code;
  }

  hasCode(): boolean {
    return Boolean(this.code);
  }
}
